import { render, staticRenderFns } from "./CommandLists.vue?vue&type=template&id=3586ace2"
import script from "./CommandLists.vue?vue&type=script&lang=js"
export * from "./CommandLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports